var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "baseline-beenhere-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1807",
    "data-name": "Path 1807",
    d: "M0,0H75V75H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1808",
    "data-name": "Path 1808",
    d: "M56.5,1H9.688A6.524,6.524,0,0,0,3.033,7.369L3,48.547a6.31,6.31,0,0,0,2.943,5.287L33.094,71.063,60.212,53.834a6.31,6.31,0,0,0,2.943-5.287l.033-41.178A6.554,6.554,0,0,0,56.5,1ZM26.407,48.77,9.688,32.847l4.715-4.49,12,11.4L51.786,15.586,56.5,20.108Z",
    transform: "translate(4.406 1.469)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessSvg);
export default __webpack_public_path__ + "static/media/successSvg.8b269ff59476a6e89d97d6019dfa162c.svg";
export { ForwardRef as ReactComponent };